import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Marca } from '../../componentes/Marca';
import { BotaoLink, cx } from '../../componentes/ui';
import { useSessao } from '../../auth/SessaoContext';
import css from './Cabecalho.module.css';

const LINKS = [
  {
    ancora: 'como-funciona',
    rotulo: 'Como funciona',
    clique: 'nav-como-funciona',
  },
  {
    ancora: 'escritorios',
    rotulo: 'Para escritórios',
    clique: 'nav-escritorios',
  },
  { ancora: 'captura', rotulo: 'Captura automática', clique: 'nav-captura' },
  { ancora: 'precos', rotulo: 'Preços', clique: 'nav-precos' },
  { ancora: 'seguranca', rotulo: 'Segurança', clique: 'nav-seguranca' },
  { ancora: 'duvidas', rotulo: 'Dúvidas', clique: 'nav-duvidas' },
];

/**
 * Topo das páginas públicas.
 *
 * Na home, os links são âncoras (`#precos`); nas outras páginas apontam para a
 * home (`/#precos`). No celular, "Criar conta" continua visível e o resto vai
 * para o menu — esconder a navegação inteira deixava a página sem saída.
 */
export function Cabecalho({ naHome = false }: { naHome?: boolean }) {
  const { usuario } = useSessao();
  const [aberto, setAberto] = useState(false);
  const prefixo = naHome ? '#' : '/#';

  useEffect(() => {
    if (!aberto) return;
    const aoTeclar = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setAberto(false);
    };
    window.addEventListener('keydown', aoTeclar);
    return () => window.removeEventListener('keydown', aoTeclar);
  }, [aberto]);

  return (
    <header className={cx(css.topo, aberto && css.topoAberto)}>
      <div className={css.barra}>
        <Link
          to="/"
          className={css.marca}
          aria-label="baixaxml — página inicial"
        >
          <Marca tamanho={24} fonte={20} />
        </Link>

        <nav className={css.nav} aria-label="Seções">
          {LINKS.map((l) => (
            <a
              key={l.ancora}
              href={prefixo + l.ancora}
              data-clique={l.clique}
              className={css.link}
            >
              {l.rotulo}
            </a>
          ))}
          <Link
            to="/desenvolvedores"
            data-clique="nav-api"
            className={css.link}
          >
            API
          </Link>
        </nav>

        <div className={css.acoes}>
          {usuario ? (
            <BotaoLink to="/painel" pequeno>
              Ir para o painel
            </BotaoLink>
          ) : (
            <>
              <Link
                to="/entrar"
                data-clique="entrar-topo"
                className={cx(css.link, css.entrar)}
              >
                Entrar
              </Link>
              <BotaoLink
                to="/criar-conta"
                pequeno
                data-clique="criar-conta-topo"
              >
                Criar conta
              </BotaoLink>
            </>
          )}
          <button
            type="button"
            className={css.hamburguer}
            aria-expanded={aberto}
            aria-controls="menu-publico"
            aria-label={aberto ? 'Fechar menu' : 'Abrir menu'}
            onClick={() => setAberto((v) => !v)}
          >
            {aberto ? <X aria-hidden="true" /> : <Menu aria-hidden="true" />}
          </button>
        </div>
      </div>

      <div id="menu-publico" className={css.gaveta} hidden={!aberto}>
        {LINKS.map((l) => (
          <a
            key={l.ancora}
            href={prefixo + l.ancora}
            data-clique={l.clique}
            className={css.itemGaveta}
            onClick={() => setAberto(false)}
          >
            {l.rotulo}
          </a>
        ))}
        <Link
          to="/desenvolvedores"
          data-clique="nav-api"
          className={css.itemGaveta}
          onClick={() => setAberto(false)}
        >
          API para desenvolvedores
        </Link>
        {!usuario && (
          <Link
            to="/entrar"
            data-clique="entrar-topo"
            className={css.itemGaveta}
            onClick={() => setAberto(false)}
          >
            Entrar na conta
          </Link>
        )}
      </div>
    </header>
  );
}
